module.exports = __webpack_public_path__ + "static/img/chery_8@2x.7138a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/chery_8@2x.png
// module id = j9fJ
// module chunks = 0